import type { UtentiPaginationDTO } from '@/models/dto/utente/utenti-pagination-dto'
import type { User } from '../../types/user/user'
import type { UsersWithPagination } from '../../types/user/users-with-pagination'
import { mapToPagination, mapToPaginationDTO } from '../pagination-mapper'
import { mapToUser, mapToUtentiDTO } from './user-mapper'

const mapToUtentiPaginationDTO = (users: UsersWithPagination): UtentiPaginationDTO => {
    return {
        utenti: users.users?.map((user: User) => mapToUtentiDTO(user)) ?? [],
        paginationData: users.pagination ? mapToPaginationDTO(users.pagination) : null,
    }
}

const mapToUsersWithPagination = (utentiPaginationDTO: UtentiPaginationDTO): UsersWithPagination => {
    return {
        users: utentiPaginationDTO.utenti ? utentiPaginationDTO.utenti.map((utenteDTO) => mapToUser(utenteDTO)) : [],
        pagination: utentiPaginationDTO.paginationData
            ? mapToPagination(utentiPaginationDTO.paginationData)
            : undefined,
    }
}

export { mapToUsersWithPagination, mapToUtentiPaginationDTO }
